export const _setCompany = (state, action) => {
  state.company = action.payload;
};

export const _setDocumentType = (state, action) => {
  state.documentType = action.payload;
};

export const _setIncludeExpired = (state, action) => {
  state.includeExpired = action.payload;
};

export const _setIsActiveCompanyAssociation = (state, action) => {
  state.isActiveCompanyAssociation = action.payload;
};
